import { render } from "./performance-review.vue?vue&type=template&id=65322eb3"
import script from "./performance-review.vue?vue&type=script&lang=js"
export * from "./performance-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__